import React, { useState, useEffect, useRef } from 'react'
import Lottie from 'lottie-react'
import rotateScreenAnimation from '../../assets/rotate-phone.json'
import ClipLoader from "react-spinners/ClipLoader";
import { loadLCAlarmLevels, Alarm, loadLoggerAlarmLevels, loadSiteAlarmLevels, checkAlarmAxisLevels } from '../../components/Graphing Functions/GraphAlarmLevelsFunctions'
import { CreateUrl, CallGetAPI, CallPostAPI } from 'Utils/ApiHelper.js';
import { APILoggerDetail, buildAPILoggerDetail } from '../../models/APILoggerDetail';
import moment from 'moment'
import { drawGraph, SiteDetails, Readings, MinMax, ImportedData } from '../../components/Graphing Functions/GraphUtilityFunctions'
import { VisualRange } from 'devextreme-react/common/charts';
import { APIGetLoggerReadingsModel, buildAPIGetLoggerReadingsModel } from '../../models/APIGetLoggerReadingsModel';
import { GraphTemplate, graphTemplateModel, GraphSettings, deepCopyAshridgeDefault } from '../../models/GraphTemplateModel'
import Chart, { Grid as GridChart, ConstantLine, CommonSeriesSettings, ArgumentAxis, Export, Series, Legend, ValueAxis, ZoomAndPan, ScrollBar, Tooltip, TickInterval, Aggregation, Point, Title, AggregationInterval, Label, Height, Crosshair, Font, MinorTickInterval, Tick, MinorTick, Strip, CommonAxisSettings, VisualRangeChangeEvent } from 'devextreme-react/chart';
import { colors } from '../../components/Graphing Functions/GraphColors'
import { FormattedMessage, IntlShape, useIntl } from 'react-intl';
import { flowConverter, pressureConverter, totalConverter, flowRateUnits, flowUnits, pressureUnits } from '../../Utils/UnitConverters'
import { renderTooltip } from '../../components/Graphing Functions/GraphRenderTooltip'
import { Ashridge } from '../../assets/jss/material-dashboard-react'
import FullWidthMobileButton from '../../components/FullWidthMobileButton';
import DateRange from '../../components/Dates/DateRange';
import { onDateChange } from '../../components/Graphing Functions/GraphDateChangeFunctions'
import { useMobileLandscape, useTabletContext } from '../../Context/ContextProvider'
import Loader from '../../Utils/Loader/NewLoader2025'
import SlideInAnimation from '../../Animation Wrappers/SlideInAnimation';
import { renderImportedDataStrips } from '../../components/Graphing Functions/GraphImportDataRender'
import {CombinedFlowUnits } from '../../components/Graphing Functions/GraphCombineFlowFunctions'

interface Props {
    classes: {
        cardTitleWhite: string;
        formControl: string;
        cardCategoryWhite: string;
    };
    history: {
        goBack: () => void;
    };
    location: {
        state: {
            groupId: number | null;
            loggers: Array<number>;
            showBackButton: boolean;
            site: number | null;
        }
    }
    startDateProps: Date;
    endDateProps: Date;
    showDates: boolean;
    ref: React.RefObject<unknown>;
    fullscreen: boolean
    handleDateUpdate: (startDate: Date, endDate: Date) => void | null
}



const MultiLoggerGraphMobile: React.FC<Props> = ({ classes, history, location, startDateProps, endDateProps, showDates, fullscreen, handleDateUpdate }) => {
    //hooks / context
    const isLandscape = useMobileLandscape()
    const isTablet = useTabletContext()
    const [loading, setLoading] = useState<boolean>(false)
    const [alarms, setAlarms] = useState<Array<Alarm>>([])
    const [checkAlarms, setCheckAlarms] = useState<boolean>(false)
    const [startDate, setStartDate] = useState<Date>((startDateProps != null ? moment(startDateProps).toDate() : moment().subtract(1, "days")).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate(),)
    const [endDate, setEndDate] = useState<Date>(endDateProps != null ? moment(endDateProps).toDate() : moment().toDate())
    const [loggerSiteDetails, setLoggerSiteDetails] = useState<Array<SiteDetails>>([])
    const [ashridgeDefaultInUse, setAshridgeDefaultInUse] = useState<boolean>(false)
    const [APIFailed, setAPIFailed] = useState<boolean>(false)
    const [authorised, setAuthorised] = useState<boolean>(true)
    const [visualRange, setVisualRange] = useState<VisualRange>({ startValue: startDate, endValue: endDate })
    const [hasFlow, setHasFlow] = useState<boolean>(false)
    const [hasPressureChannels, setHasPressureChannels] = useState<boolean>(false)
    const [hasTotal, setHasTotal] = useState<boolean>(false)
    const [hasConsumption, setHasConsumption] = useState<boolean>(false)
    const [hasDigital, setHasDigital] = useState<boolean>(false)
    const [showFlow, setShowFlow] = useState<boolean>(false)
    const [showPressure, setShowPressure] = useState<boolean>(false)
    const [showMinMax, setShowMinMax] = useState<boolean>(false)
    const [showTotal, setShowTotal] = useState<boolean>(false)
    const [showDigital, setShowDigital] = useState<boolean>(false)
    const [showConsumption, setShowConsumption] = useState<boolean>(false)
    const [readingsData, setReadingsData] = useState<Array<APIGetLoggerReadingsModel>>([])
    const [graphData, setGraphData] = useState<Array<Readings>>([])
    const [unitsAndValues, setUnitsAndValues] = useState<Array<GraphTemplate>>([])
    const [loggers, setLoggers] = useState<Array<APILoggerDetail>>([])
    const [loggersToTemplate, setLoggersToTemplate] = useState<number | null>(null)
    const [noLoggersInGroup, setNoLoggersInGroup] = useState<boolean>(false)
    const [siteNameUserFriendly, setSiteNameUserFriendly] = useState<string>("")
    const [tooltipVisible, setTooltipVisible] = useState(false);
    const [shouldReloadData, setShouldReloadData] = useState<boolean>(false)
    const [showButton, setShowButton] = useState<boolean>(false)
    const [showDatePicker, setShowDatePicker] = useState<boolean>(false)
    const [showShowHide, setShowShowHide] = useState<boolean>(false)
    const [specifyTime, setSpecifyTime] = useState<boolean>(false)
    const [minMaxData, setMinMaxData] = useState<MinMax[]>()
    const [importData, setImportData] = useState<ImportedData>()
    const [combinedFlowUnits, setCombinedFlowUnits] = useState<CombinedFlowUnits>({ A: "", B: "" })

    const chartRef = useRef(null)
    const intl: IntlShape = useIntl()

    useEffect(() => {
        reloadData(location.state?.groupId ? location.state?.groupId : 0, location.state?.loggers, location.state?.site, true)
    }, [])


    ///find mid point date for where toiltip shoul render



    const reloadData = (groupId: number | null, loggersProps: Array<number>, site: number | null, dateChange: boolean | null): boolean => {
        console.log(groupId, loggersProps, site, dateChange)
        setAlarms([])
        setLoading(true)
        setCheckAlarms(false)
        if (groupId != null && groupId != 0) {

            // Group selected - graph loggers deployed to sites in group
            CallGetAPI(CreateUrl('/api/aquaguard/GetAllLoggersForGroup?groupid=' + groupId), {})
                .then(data => {

                    if (data.length > 0) {

                        let siteId = 0;
                        // Copy the data records into deviceData, adding the clickEvent
                        const records: Array<APILoggerDetail> = [];
                        for (let i = 0; i < data.length; i++) {
                            const rec = buildAPILoggerDetail(data[i])
                            records.push(rec);

                            if (rec.FkSiteId != null) {
                                if (siteId == 0) {
                                    siteId = rec.FkSiteId;
                                }
                                else {
                                    // Check if all loggers from same site
                                    if (siteId != rec.FkSiteId) {
                                        siteId = -1;
                                    }
                                }
                            }
                        }

                        //// Load alarm levels if single Chariot logger
                        if (records.length === 1) {
                            if (records[0].LoggerId > 500000) {
                                loadLCAlarmLevels(records[0].Serial, setAlarms)
                            }
                            else {
                                loadLoggerAlarmLevels(records[0].Serial, startDate, endDate, setAlarms);
                            }
                        }

                        if (siteId > 0) {
                            // Load alarm levels for Site if all loggers deployed to same site
                            if (records[0].FkSiteId != null) {
                                loadSiteAlarmLevels(siteId, alarms, setAlarms);
                            }
                        }


                        drawGraph(
                            records,
                            null,
                            dateChange,
                            setLoggerSiteDetails,
                            setLoading,
                            setAshridgeDefaultInUse,
                            setAPIFailed,
                            setAuthorised,
                            startDate,
                            endDate,
                            setStartDate,
                            setVisualRange,
                            setHasFlow,
                            setHasTotal,
                            setHasConsumption,
                            setHasPressureChannels,
                            setShowMinMax,
                            setShowFlow,
                            setShowPressure,
                            setShowTotal,
                            setShowConsumption,
                            setGraphData,
                            setReadingsData,
                            setUnitsAndValues,
                            setCheckAlarms,
                            setLoggers,
                            setLoggersToTemplate,
                            setHasDigital,
                            setShowDigital,
                            setMinMaxData,
                            setImportData
                        );

                    }
                    else {

                        setNoLoggersInGroup(true)
                        setLoading(false)
                    }

                })
                .catch((error) => {
                    console.log(error);
                    setAPIFailed(true)
                    setAuthorised(false)

                })
        }


        if (loggersProps?.length > 0) {
            // List of loggers selected

            const loggerIds: Array<{ Id: number }> = [];
            let selectedLoggers: Array<number> = []
            const selectedFromStorage = sessionStorage.getItem('selectedLoggers')
            if (selectedFromStorage) {
                if (loggersProps.length > 1) {
                    selectedLoggers = selectedFromStorage.split(',').map(item => parseInt(item))
                } else {
                    selectedLoggers.push(parseInt(selectedFromStorage))
                }
            }
            console.log(selectedLoggers, loggersProps)
            if (loggersProps.length > 0) {
                loggersProps.map((l) => {
                    console.log(l)
                    if (selectedLoggers.includes(l)) {
                        console.log(l)
                        loggerIds.push({ Id: l });
                    }
                });
            }
            console.log(loggerIds)
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(loggerIds)
            };
            console.log(requestOptions)
            CallGetAPI(CreateUrl('/api/aquaguard/LoggerDetailsByIdList'), requestOptions)
                .then(data => {
                    console.log(data)

                    if (data.length > 0) {

                        // Copy the data records into deviceData, adding the clickEvent
                        const records: Array<APILoggerDetail> = [];
                        let siteId = 0;
                        for (let i = 0; i < data.length; i++) {
                            const rec = buildAPILoggerDetail(data[i])

                            records.push(rec);

                            if (rec.FkSiteId != null) {
                                if (siteId == 0) {
                                    siteId = rec.FkSiteId;
                                }
                                else {
                                    // Check if all loggers from same site
                                    if (siteId != rec.FkSiteId) {
                                        siteId = -1;
                                    }
                                }
                            }
                        }

                        // Load alarm levels if single Chariot logger
                        if (records.length === 1) {
                            if (records[0].LoggerId > 500000) {
                                loadLCAlarmLevels(records[0].Serial, setAlarms, alarms)
                            }
                            else {

                                loadLoggerAlarmLevels(records[0].Serial, startDate, endDate, alarms, setAlarms);
                            }
                        }

                        drawGraph(
                            records,
                            null,
                            dateChange,
                            setLoggerSiteDetails,
                            setLoading,
                            setAshridgeDefaultInUse,
                            setAPIFailed,
                            setAuthorised,
                            startDate,
                            endDate,
                            setStartDate,
                            setVisualRange,
                            setHasFlow,
                            setHasTotal,
                            setHasConsumption,
                            setHasPressureChannels,
                            setShowMinMax,
                            setShowFlow,
                            setShowPressure,
                            setShowTotal,
                            setShowConsumption,
                            setGraphData,
                            setReadingsData,
                            setUnitsAndValues,
                            setCheckAlarms,
                            setLoggers,
                            setLoggersToTemplate,
                            setHasDigital,
                            setShowDigital,
                            setMinMaxData,
                            setImportData
                        );

                    }
                    else {
                        drawGraph(
                            [],
                            null,
                            dateChange,
                            setLoggerSiteDetails,
                            setLoading,
                            setAshridgeDefaultInUse,
                            setAPIFailed,
                            setAuthorised,
                            startDate,
                            endDate,
                            setStartDate,
                            setVisualRange,
                            setHasFlow,
                            setHasTotal,
                            setHasConsumption,
                            setHasPressureChannels,
                            setShowMinMax,
                            setShowFlow,
                            setShowPressure,
                            setShowTotal,
                            setShowConsumption,
                            setGraphData,
                            setReadingsData,
                            setUnitsAndValues,
                            setCheckAlarms,
                            setLoggers,
                            setLoggersToTemplate,
                            setHasDigital,
                            setShowDigital,
                            setMinMaxData,
                            setImportData
                        );
                    }

                })
                .catch((error) => {
                    console.log(error)
                    setAPIFailed(true)
                    setAuthorised(false)

                });
        }

        // For site just pull readings and alarm levels for site
        if (site != null && site != 0) {
            let extractedData = []
            let loggerIds: Array<{ Id: number }> = [];
            //TODO: Need to get SiteUserFriendlyName
            CallGetAPI(CreateUrl('/api/aquaguard/site?id=' + site), {})
                .then(data => {

                    if (data.siteNameUserFriendly != null) {
                        setSiteNameUserFriendly(data.siteNameUserFriendly.length > 0 ? data.siteNameUserFriendly : data.siteName)
                    }
                    else {
                        setSiteNameUserFriendly(data.siteName.length > 0 ? data.siteName : "")
                    }

                    CallGetAPI(CreateUrl('/api/aquaguard/HistoryForSite?siteId=' + site), {})
                        .then(data => {

                            extractedData = []
                            extractedData = data.filter(item => {

                                if (!moment(item.startDate).isAfter(endDate)) {
                                    if (item.endDate === null) {
                                        return item
                                    } else if (!moment(item.endDate).isBefore(startDate)) {

                                        return item
                                    }
                                }
                            })
                            extractedData = extractedData.filter((item, index, self) => index === self.findIndex(obj => obj.serial === item.serial))

                            if (extractedData.length > 0) {
                                loggerIds = []
                                extractedData.forEach(p => loggerIds.push({ Id: p.loggerId }))
                                const requestOptions = {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify(loggerIds)
                                };

                                CallGetAPI(CreateUrl('/api/aquaguard/LoggerDetailsByIdList'), requestOptions)
                                    .then(data => {
                                        const records: Array<APILoggerDetail> = [];
                                        const siteDeetsTemp = []
                                        for (let i = 0; i < data.length; i++) {
                                            const rec = buildAPILoggerDetail(data[i])

                                            records.push(rec);

                                            siteDeetsTemp.push({ siteRef: data.SiteName, siteName: data.SiteNameUserFriendly, serial: rec.Serial })
                                        }
                                        setLoggerSiteDetails(siteDeetsTemp)
                                        drawGraph(
                                            records,
                                            site,
                                            dateChange,
                                            setLoggerSiteDetails,
                                            setLoading,
                                            setAshridgeDefaultInUse,
                                            setAPIFailed,
                                            setAuthorised,
                                            startDate,
                                            endDate,
                                            setStartDate,
                                            setVisualRange,
                                            setHasFlow,
                                            setHasTotal,
                                            setHasConsumption,
                                            setHasPressureChannels,
                                            setShowMinMax,
                                            setShowFlow,
                                            setShowPressure,
                                            setShowTotal,
                                            setShowConsumption,
                                            setGraphData,
                                            setReadingsData,
                                            setUnitsAndValues,
                                            setCheckAlarms,
                                            setLoggers,
                                            setLoggersToTemplate,
                                            setHasDigital,
                                            setShowDigital,
                                            setMinMaxData,
                                            setImportData
                                        );
                                    })
                            } else {
                                drawGraph(
                                    [],
                                    site,
                                    dateChange,
                                    setLoggerSiteDetails,
                                    setLoading,
                                    setAshridgeDefaultInUse,
                                    setAPIFailed,
                                    setAuthorised,
                                    startDate,
                                    endDate,
                                    setStartDate,
                                    setVisualRange,
                                    setHasFlow,
                                    setHasTotal,
                                    setHasConsumption,
                                    setHasPressureChannels,
                                    setShowMinMax,
                                    setShowFlow,
                                    setShowPressure,
                                    setShowTotal,
                                    setShowConsumption,
                                    setGraphData,
                                    setReadingsData,
                                    setUnitsAndValues,
                                    setCheckAlarms,
                                    setLoggers,
                                    setLoggersToTemplate,
                                    setShowDigital,
                                    setMinMaxData,
                                    setImportData
                                );
                            }

                        })

                })
                .catch((error) => {
                    console.log(error);
                    setAPIFailed(true)
                    setAuthorised(false)
                });



        }

        return true;
    }

    const renderLoggerSeries = (logger: APILoggerDetail): React.ReactNode => {
        let counter = 0
        const loggerSeries = []


        unitsAndValues.map(item => {


            const i = item.graphSettings
            //flow A
            let flowAVisibleLogger = false
            let flowAGraphType = ""
            let flowAColor = ''
            let flowALineWidth = 0

            //Total A
            let flowATotalVisibleLogger = false
            let flowATotalGraphType = ""
            let flowATotalColor = ''
            let flowATotalLineWidth = 0


            //Consumption A
            let flowAConsumptionVisibleLogger = false
            let flowAConsumptionGraphType = ""
            let flowAConsumptionColor = ''
            let flowAConsumptionLineWidth = 0

            //flow B
            let flowBVisibleLogger = false
            let flowBGraphType = ""
            let flowBColor = ''
            let flowBLineWidth = 0

            //Total B
            let flowBTotalVisibleLogger = false
            let flowBTotalGraphType = ""
            let flowBTotalColor = ''
            let flowBTotalLineWidth = 0

            //Consumption B
            let flowBConsumptionVisibleLogger = false
            let flowBConsumptionGraphType = ""
            let flowBConsumptionColor = ''
            let flowBConsumptionLineWidth = 0

            //pressure C
            let pressureCVisibleLogger = false
            let pressureCGraphType = ""
            let pressureCColor = ''
            let pressureCLineWidth = 0
            let pressureCValueField = `${logger.Serial}readingC`
            const pressureCMinValueField = `${logger.Serial}readingCmin`
            const pressureCMaxValueField = `${logger.Serial}readingCmax`

            //pressure D
            let pressureDVisibleLogger = false
            let pressureDGraphType = ""
            let pressureDColor = ''
            let pressureDLineWidth = 0
            let pressureDValueField = `${logger.Serial}readingD`
            const pressureDMinValueField = `${logger.Serial}readingDmin`
            const pressureDMaxValueField = `${logger.Serial}readingDmax`

            //pressure E
            let pressureEVisibleLogger = false
            let pressureEGraphType = ""
            let pressureEColor = ''
            let pressureELineWidth = 0
            let pressureEValueField = `${logger.Serial}readingE`
            const pressureEMinValueField = `${logger.Serial}readingEmin`
            const pressureEMaxValueField = `${logger.Serial}readingEmax`

            if (item.serial === logger.Serial) {
                //flow A
                flowAVisibleLogger = i.flowAVisible
                flowAGraphType = i.flowAGraphType
                flowALineWidth = i.flowALineWidth

                ///Total A
                flowATotalVisibleLogger = i.flowATotalVisible
                flowATotalGraphType = i.flowATotalGraphType
                flowATotalLineWidth = i.flowATotalLineWidth

                ///Consumption A

                flowAConsumptionVisibleLogger = i.flowAConsumptionVisible
                flowAConsumptionGraphType = i.flowAConsumptionGraphType
                flowAConsumptionLineWidth = i.flowAConsumptionLineWidth


                //flow B
                flowBVisibleLogger = i.flowBVisible
                flowBGraphType = i.flowBGraphType
                flowBLineWidth = i.flowBLineWidth
                ///Total B
                flowBTotalVisibleLogger = i.flowBTotalVisible
                flowBTotalGraphType = i.flowBTotalGraphType
                flowBTotalLineWidth = i.flowBTotalLineWidth
                ///Consumption A
                flowBConsumptionVisibleLogger = i.flowBConsumptionVisible
                flowBConsumptionGraphType = i.flowBConsumptionGraphType
                flowBConsumptionLineWidth = i.flowBConsumptionLineWidth

                //pressure C
                pressureCVisibleLogger = i.pressureCVisible
                pressureCGraphType = i.pressureCGraphType
                pressureCLineWidth = i.pressureCLineWidth
                //pressure D
                pressureDVisibleLogger = i.pressureDVisible
                pressureDGraphType = i.pressureDGraphType
                pressureDLineWidth = i.pressureDLineWidth
                //pressure E
                pressureEVisibleLogger = i.pressureEVisible
                pressureEGraphType = item.graphSettings.pressureEGraphType
                pressureELineWidth = item.graphSettings.pressureELineWidth
            }

            if (!i.pressureCDisplayAll) {
                if (i.pressureCValueAs === 'max') {
                    pressureCValueField = `${logger.Serial}readingCmax`
                }
                if (i.pressureCValueAs === 'min') {
                    pressureCValueField = `${logger.Serial}readingCmin`
                }
            }
            if (!i.pressureDDisplayAll) {
                if (i.pressureDValueAs === 'max') {
                    pressureDValueField = `${logger.Serial}readingDmax`
                }
                if (i.pressureDValueAs === 'min') {
                    pressureDValueField = `${logger.Serial}readingDmin`
                }
            }
            if (!i.pressureEDisplayAll) {
                if (i.pressureEValueAs === 'max') {
                    pressureEValueField = `${logger.Serial}readingEmax`
                }
                if (i.pressureEValueAs === 'min') {
                    pressureEValueField = `${logger.Serial}readingEmin`
                }
            }

            if (item.isAshridgeDefault) {
                flowAColor = colors.red[counter]
                flowATotalColor = colors.yellow[counter]
                flowAConsumptionColor = colors.teal[counter]
                flowBTotalColor = colors.brown[counter]
                flowBColor = colors.green[counter]
                flowBConsumptionColor = colors.pink[counter]
                pressureCColor = colors.blue[counter]
                pressureDColor = colors.orange[counter]
                pressureEColor = colors.purple[counter]
                counter === 9 ? counter = 0 : counter++;
            } else {
                if (i.flowADefaultColor) {
                    flowAColor = colors.red[counter];
                } else {
                    flowAColor = i.flowAColor;
                }
                if (i.flowATotalDefaultColor) {
                    flowATotalColor = colors.yellow[counter];
                } else {
                    flowATotalColor = i.flowATotalColor;
                }
                if (i.flowAConsumptionDefaultColor) {
                    flowAConsumptionColor = colors.teal[counter];
                } else {
                    flowAConsumptionColor = i.flowAConsumptionColor;
                }
                if (i.flowBDefaultColor) {
                    flowBColor = colors.green[counter];
                } else {
                    flowBColor = i.flowBColor;
                }
                if (i.flowBTotalDefaultColor) {
                    flowBTotalColor = colors.brown[counter];
                } else {
                    flowBTotalColor = i.flowBTotalColor;
                }
                if (i.flowBConsumptionDefaultColor) {
                    flowBConsumptionColor = colors.pink[counter];
                } else {
                    flowBConsumptionColor = i.flowBConsumptionColor;
                }
                if (i.pressureCDefaultColor) {
                    pressureCColor = colors.blue[counter]
                } else {
                    pressureCColor = i.pressureCColor


                }
                if (i.pressureDDefaultColor) {
                    pressureDColor = colors.orange[counter]
                } else {
                    pressureDColor = i.pressureDColor
                }
                if (i.pressureEDefaultColor) {
                    pressureEColor = colors.purple[counter]
                } else {
                    pressureEColor = i.pressureEColor
                }
                counter === 9 ? counter = 0 : counter++;
            }



            if ((flowAVisibleLogger && item.channelsAvail & 0x01)) {
                loggerSeries.push(<Series
                    color={flowAColor}
                    key={`${logger.Serial}-A`}
                    type={flowAGraphType}
                    axis={`A ${logger.Serial}`}
                    valueField={`${logger.Serial}flowRateA`}
                    name={`A ${logger.Serial}`}
                    point={{ visible: false }}
                    width={flowALineWidth}
                    barWidth={flowALineWidth} />)
            }
            if (flowATotalVisibleLogger && item.channelsAvail & 0x01 && (i.flowATotalMaxValue !== Number.NEGATIVE_INFINITY || i.flowATotalMaxValue !== null)) {
                loggerSeries.push(<Series
                    color={flowATotalColor}
                    key={`${logger.Serial}-A-Total`}
                    type={flowATotalGraphType}
                    axis={`AT-Total ${logger.Serial}`}
                    valueField={`${logger.Serial}readingA`}
                    name={`AT-Total ${logger.Serial}`}
                    point={{ visible: false }}
                    width={flowATotalLineWidth}
                    barWidth={flowATotalLineWidth} />)
            }

            if (flowAConsumptionVisibleLogger && item.channelsAvail & 0x01 && (i.flowAConsumptionMaxValue !== Number.NEGATIVE_INFINITY || i.flowAConsumptionMaxValue !== null)) {

                loggerSeries.push(<Series
                    color={flowAConsumptionColor}
                    key={`${logger.Serial}-AC-Consumption`}
                    type={flowAConsumptionGraphType}
                    axis={`AC-Consumption ${logger.Serial}`}
                    valueField={`${logger.Serial}consumptionA`}
                    name={`AC-Consumption ${logger.Serial}`}
                    point={{ visible: false }}
                    width={flowAConsumptionLineWidth}
                    barWidth={flowAConsumptionLineWidth} />)
            }
            if (flowBVisibleLogger && item.channelsAvail & 0x02) {
                loggerSeries.push(<Series
                    color={flowBColor}
                    key={`${logger.Serial}-B`}
                    type={flowBGraphType}
                    axis={`B ${logger.Serial}`}
                    valueField={`${logger.Serial}flowRateB`}
                    name={`B ${logger.Serial}`}
                    point={{ visible: false }}
                    width={flowBLineWidth}
                    barWidth={flowBLineWidth} />)
            }
            if (flowBTotalVisibleLogger && item.channelsAvail & 0x02 && i.flowBTotalMaxValue !== Number.NEGATIVE_INFINITY) {
                loggerSeries.push(<Series
                    color={flowBTotalColor}
                    key={`${logger.Serial}-B-Total`}
                    type={flowBTotalGraphType}
                    axis={`BT-Total ${logger.Serial}`}
                    valueField={`${logger.Serial}readingB`}
                    name={`BT-Total ${logger.Serial}`}
                    point={{ visible: false }}
                    width={flowBTotalLineWidth}
                    barWidth={flowBTotalLineWidth} />)
            }
            if (flowBConsumptionVisibleLogger && item.channelsAvail & 0x02 && i.flowBConsumptionMaxValue !== Number.NEGATIVE_INFINITY) {
                loggerSeries.push(<Series
                    color={flowBConsumptionColor}
                    key={`${logger.Serial}-BC-Consumption`}
                    type={flowBConsumptionGraphType}
                    axis={`BC-Consumption ${logger.Serial}`}
                    valueField={`${logger.Serial}consumptionB`}
                    name={`BC-Consumption ${logger.Serial}`}
                    point={{ visible: false }}
                    width={flowBConsumptionLineWidth}
                    barWidth={flowBConsumptionLineWidth} />)
            }
            if (i.pressureCDisplayAll && unitsAndValues.length === 1 && item.channelsAvail & 0x04 && pressureCVisibleLogger && pressureCGraphType === 'spline' && pressureCMinValueField !== null && pressureCMaxValueField !== null) {
                loggerSeries.push(<Series
                    color={pressureCColor + '65'}
                    key={`${logger.Serial}-CRange`}
                    type='rangeArea'
                    axis={`C ${logger.Serial}`}
                    rangeValue1Field={pressureCMinValueField}
                    rangeValue2Field={pressureCMaxValueField}
                    name={`C ${logger.Serial}`}
                    point={{ visible: false }}
                    width={pressureCLineWidth}
                    barWidth={pressureCLineWidth}


                />)
            }
            if (pressureCVisibleLogger && item.channelsAvail & 0x04) {
                loggerSeries.push(<Series
                    color={pressureCColor}
                    key={`${logger.Serial}-C`}
                    type={pressureCGraphType}
                    axis={`C ${logger.Serial}`}
                    valueField={pressureCValueField}
                    name={`C ${logger.Serial}`}
                    point={{ visible: false }}
                    width={pressureCLineWidth}
                    barWidth={pressureCLineWidth}

                />)
            }
            if (i.pressureDDisplayAll && unitsAndValues.length === 1 && item.channelsAvail & 0x08 && pressureDVisibleLogger && pressureDGraphType === 'spline' && pressureDMinValueField !== null && pressureDMaxValueField !== null) {
                loggerSeries.push(<Series
                    color={pressureDColor + '65'}
                    key={`${logger.Serial}-DRange`}
                    type='rangeArea'
                    axis={`D ${logger.Serial}`}
                    rangeValue1Field={pressureDMinValueField}
                    rangeValue2Field={pressureDMaxValueField}
                    name={`D ${logger.Serial}`}
                    point={{ visible: false }}
                    width={pressureDLineWidth}
                    barWidth={pressureDLineWidth}


                />)
            }
            if (pressureDVisibleLogger && item.channelsAvail & 0x08) {
                loggerSeries.push(<Series
                    color={pressureDColor}
                    key={`${logger.Serial}-D`}
                    type={pressureDGraphType}
                    axis={`D ${logger.Serial}`}
                    valueField={pressureDValueField}
                    name={`D ${logger.Serial}`}
                    point={{ visible: false }}
                    width={pressureDLineWidth}
                    barWidth={pressureDLineWidth} />)
            }

            if (pressureEVisibleLogger && item.channelsAvail & 0x10) {
                loggerSeries.push(<Series
                    color={pressureEColor}
                    key={`${logger.Serial}-E`}
                    type={pressureEGraphType}
                    axis={`E ${logger.Serial}`}
                    valueField={pressureEValueField}
                    name={`E ${logger.Serial}`}
                    point={{ visible: false }} // This hides individual points
                    width={pressureELineWidth}
                    barWidth={pressureELineWidth}


                />)
            }
            if (i.pressureEDisplayAll && unitsAndValues.length === 1 && item.channelsAvail & 0x10 && pressureEVisibleLogger && pressureEGraphType === 'spline' && pressureEMinValueField !== null && pressureEMaxValueField !== null) {
                loggerSeries.push(<Series
                    color={pressureEColor + '65'}
                    key={`${logger.Serial}-ERange`}
                    type='rangeArea'
                    axis={`E ${logger.Serial}`}
                    rangeValue1Field={pressureEMinValueField}
                    rangeValue2Field={pressureEMaxValueField}
                    name={`E ${logger.Serial}`}
                    point={{ visible: false }}
                    width={pressureELineWidth}
                    barWidth={pressureELineWidth}


                />)
            }
        })
        return loggerSeries
    }

    const renderValueAxis = (logger) => {
        let counter = 0;
        const valueAxisArray = [];


        unitsAndValues.map(item => {
            const hasAlarms = item.alarms.length > 0
            const i = item.graphSettings
            // flow A
            let flowAMinValueLogger = 0;
            let flowAMaxValueLogger = 0; // Default value now dynamic
            let flowAColor = '';
            let flowAVisibleLogger = false;
            let flowAAxisPosition = '';
            let flowALabelSize = 0;
            let flowAUnit = '';


            ///Total A
            let flowATotalMinValueLogger = 0;
            let flowATotalMaxValueLogger = 0; // Default value now dynamic
            let flowATotalColor = '';
            let flowATotalVisibleLogger = false;
            let flowATotalAxisPosition = '';
            let flowATotalLabelSize = 0;
            let flowATotalUnit = '';
            let flowATotal24Hrs = false


            ///Consumption A
            let flowAConsumptionMinValueLogger = 0;
            let flowAConsumptionMaxValueLogger = 0; // Default value now dynamic
            let flowAConsumptionColor = '';
            let flowAConsumptionVisibleLogger = false;
            let flowAConsumptionAxisPosition = '';
            let flowAConsumptionLabelSize = 0;
            let flowAConsumptionUnit = '';
            let flowAConsumption24Hrs = false

            //flow B
            let flowBMinValueLogger = 0;
            let flowBMaxValueLogger = 0; // Default value now dynamic
            let flowBColor = '';
            let flowBVisibleLogger = false;
            let flowBAxisPosition = '';
            let flowBLabelSize = 0;
            let flowBUnit = '';

            ///Consumption B
            let flowBConsumptionMinValueLogger = 0;
            let flowBConsumptionMaxValueLogger = 0; // Default value now dynamic
            let flowBConsumptionColor = '';
            let flowBConsumptionVisibleLogger = false;
            let flowBConsumptionAxisPosition = '';
            let flowBConsumptionLabelSize = 0;
            let flowBConsumptionUnit = '';
            let flowBConsumption24Hrs = false

            ///Total B
            let flowBTotalMinValueLogger = 0;
            let flowBTotalMaxValueLogger = 0; // Default value now dynamic
            let flowBTotalColor = '';
            let flowBTotalVisibleLogger = false;
            let flowBTotalAxisPosition = '';
            let flowBTotalLabelSize = 0;
            let flowBTotalUnit = '';
            let flowBTotal24Hrs = false

            //pressure C
            let pressureCMinValueLogger = 0;
            let pressureCMaxValueLogger = 0; // Default value now dynamic
            let pressureCColor = '';
            let pressureCVisibleLogger = false;
            let pressureCAxisPosition = '';
            let pressureCLabelSize = 0;
            let pressureCUnit = '';
            let pressureCChannelName = ""

            //pressure D
            let pressureDMinValueLogger = 0;
            let pressureDMaxValueLogger = 0; // Default value now dynamic
            let pressureDColor = '';
            let pressureDVisibleLogger = false;
            let pressureDAxisPosition = '';
            let pressureDLabelSize = 0;
            let pressureDUnit = '';
            let pressureDChannelName = ""

            //pressure E
            let pressureEMinValueLogger = 0;
            let pressureEMaxValueLogger = 0; // Default value now dynamic
            let pressureEColor = '';
            let pressureEVisibleLogger = false;
            let pressureEAxisPosition = '';
            let pressureELabelSize = 0;
            let pressureEUnit = '';
            let pressureEChannelName = ""
            // Match logger with item.serial and get graph settings
            if (item.serial === logger.Serial) {

                //flow A
                flowAMinValueLogger = i.flowAMinValue;
                flowAMaxValueLogger = i.flowAMaxValue;
                flowAVisibleLogger = i.flowAVisible;
                flowAAxisPosition = i.flowAAxisPosition;
                flowALabelSize = i.flowALabelSize;
                flowAUnit = i.flowAUnit;

                //Total A
                flowATotalMinValueLogger = i.flowATotalMinValue;
                flowATotalMaxValueLogger = i.flowATotalMaxValue;
                flowATotalVisibleLogger = i.flowATotalVisible;
                flowATotalAxisPosition = i.flowATotalAxisPosition;
                flowATotalLabelSize = i.flowATotalLabelSize;
                flowATotalUnit = i.flowATotalUnit;
                flowATotal24Hrs = i.flowATotalPerDay

                //Consumption A
                flowAConsumptionMinValueLogger = i.flowAConsumptionMinValue;
                flowAConsumptionMaxValueLogger = i.flowAConsumptionMaxValue;
                flowAConsumptionVisibleLogger = i.flowAConsumptionVisible;
                flowAConsumptionAxisPosition = i.flowAConsumptionAxisPosition;
                flowAConsumptionLabelSize = i.flowAConsumptionLabelSize;
                flowAConsumptionUnit = i.flowAConsumptionUnit;
                flowAConsumption24Hrs = i.flowAConsumptionPerDay

                //flow B
                flowBMinValueLogger = i.flowBMinValue;
                flowBMaxValueLogger = i.flowBMaxValue;
                flowBVisibleLogger = i.flowBVisible;
                flowBAxisPosition = i.flowBAxisPosition;
                flowBLabelSize = i.flowBLabelSize;
                flowBUnit = i.flowBUnit;

                //Total B
                flowBTotalMinValueLogger = i.flowBTotalMinValue;
                flowBTotalMaxValueLogger = i.flowBTotalMaxValue;
                flowBTotalVisibleLogger = i.flowBTotalVisible;
                flowBTotalAxisPosition = i.flowBTotalAxisPosition;
                flowBTotalLabelSize = i.flowBTotalLabelSize;
                flowBTotalUnit = i.flowBTotalUnit;
                flowBTotal24Hrs = i.flowBTotalPerDay

                //Consumption B
                flowBConsumptionMinValueLogger = i.flowBConsumptionMinValue;
                flowBConsumptionMaxValueLogger = i.flowBConsumptionMaxValue;
                flowBConsumptionVisibleLogger = i.flowBConsumptionVisible;
                flowBConsumptionAxisPosition = i.flowBConsumptionAxisPosition;
                flowBConsumptionLabelSize = i.flowBConsumptionLabelSize;
                flowBConsumptionUnit = i.flowBConsumptionUnit;
                flowBConsumption24Hrs = i.flowBConsumptionPerDay

                // pressure C
                pressureCMinValueLogger = i.pressureCMinValue
                pressureCMaxValueLogger = i.pressureCMaxValue
                pressureCVisibleLogger = i.pressureCVisible
                pressureCAxisPosition = i.pressureCAxisPosition
                pressureCLabelSize = i.pressureCLabelSize
                pressureCUnit = i.pressureCUnit

                if (pressureUnits.map(unit => unit.value).includes(pressureCUnit)) {
                    pressureCChannelName = intl.formatMessage({ id: 'Pressure C' })
                } else {
                    pressureCChannelName = intl.formatMessage({ id: 'Analog C' })
                }

                // pressure D
                pressureDMinValueLogger = i.pressureDMinValue
                pressureDMaxValueLogger = i.pressureDMaxValue
                pressureDVisibleLogger = i.pressureDVisible
                pressureDAxisPosition = i.pressureDAxisPosition
                pressureDLabelSize = i.pressureDLabelSize
                pressureDUnit = i.pressureDUnit


                if (pressureUnits.map(unit => unit.value).includes(pressureDUnit)) {
                    pressureDChannelName = intl.formatMessage({ id: 'Pressure D' })
                } else {
                    pressureDChannelName = intl.formatMessage({ id: 'Analog D' })
                }

                // pressure E
                pressureEMinValueLogger = i.pressureEMinValue
                pressureEMaxValueLogger = i.pressureEMaxValue
                pressureEVisibleLogger = i.pressureEVisible
                pressureEAxisPosition = i.pressureEAxisPosition
                pressureELabelSize = i.pressureELabelSize
                pressureEUnit = i.pressureEUnit

                if (pressureUnits.map(unit => unit.value).includes(pressureEUnit)) {
                    pressureEChannelName = intl.formatMessage({ id: 'Pressure E' })
                } else {
                    pressureEChannelName = intl.formatMessage({ id: 'Analog E' })
                }
            }

            // Handle default and non-default values for color
            if (!item.isAshridgeDefault) {
                if (i.flowADefaultColor) {
                    flowAColor = colors.red[counter];
                } else {
                    flowAColor = i.flowAColor;
                }
                if (i.flowATotalDefaultColor) {
                    flowATotalColor = colors.yellow[counter];
                } else {
                    flowATotalColor = i.flowATotalColor;
                }
                if (i.flowAConsumptionDefaultColor) {
                    flowAConsumptionColor = colors.teal[counter];
                } else {
                    flowAConsumptionColor = i.flowAConsumptionColor;
                }
                if (i.flowBDefaultColor) {
                    flowBColor = colors.green[counter];
                } else {
                    flowBColor = i.flowBColor;
                }
                if (i.flowBTotalDefaultColor) {
                    flowBTotalColor = colors.brown[counter];
                } else {
                    flowBTotalColor = i.flowBTotalColor;
                }
                if (i.flowBConsumptionDefaultColor) {
                    flowBConsumptionColor = colors.pink[counter];
                } else {
                    flowBConsumptionColor = i.flowBConsumptionColor;
                }
                if (i.pressureCDefaultColor) {
                    pressureCColor = colors.blue[counter]
                } else {
                    pressureCColor = i.pressureCColor
                }
                if (i.pressureDDefaultColor) {
                    pressureDColor = colors.orange[counter]
                } else {
                    pressureDColor = i.pressureDColor
                }
                if (i.pressureEDefaultColor) {
                    pressureEColor = colors.purple[counter]
                } else {
                    pressureEColor = i.pressureEColor
                }
                counter === 9 ? counter = 0 : counter++;
            } else {
                flowAColor = colors.red[counter];
                flowATotalColor = colors.yellow[counter];
                flowAConsumptionColor = colors.teal[counter];
                flowBColor = colors.green[counter];
                flowBTotalColor = colors.brown[counter];
                flowBConsumptionColor = colors.pink[counter];
                pressureCColor = colors.blue[counter]
                pressureDColor = colors.orange[counter]
                pressureEColor = colors.purple[counter]
                counter === 9 ? counter = 0 : counter++;
            }

            // Only render the ValueAxis if it's visible
            if (flowAVisibleLogger && item.channelsAvail & 0x01) {
                valueAxisArray.push(
                    <ValueAxis
                        width={2}
                        name={`A ${logger.Serial}`}
                        visualRange={{ startValue: flowAMinValueLogger, endValue: flowAMaxValueLogger }}
                        allowDecimals={true}
                        title={{ text: flowAMinValueLogger === Number.NEGATIVE_INFINITY && flowAMaxValueLogger === Number.NEGATIVE_INFINITY ? `${logger.Serial} ${logger.ChannelARef} - ${intl.formatMessage({ id: 'NO DATA' })} (${intl.formatMessage({ id: 'Flow A' })})` : `${logger.Serial} ${logger.ChannelARef} ${intl.formatMessage({ id: "In" })} ${flowAUnit} (${intl.formatMessage({ id: 'Flow A' })})`, font: { color: flowAColor, size: flowALabelSize } }}
                        position={flowAAxisPosition}
                        color={flowAColor}
                        key={`A-${logger.Serial}`} // Unique key for each axis
                    >
                        <Label font={{ color: flowAColor }} />
                        {hasAlarms && alarms.length > 0 && renderAlarmSeries(item.alarms.filter(alarm => alarm.channel === 'A'), item)}
                    </ValueAxis>
                );
            }
            if (flowATotalVisibleLogger && item.channelsAvail & 0x01) {
                valueAxisArray.push(
                    <ValueAxis
                        width={2}
                        name={`AT-Total ${logger.Serial}`}
                        visualRange={{ startValue: flowATotalMinValueLogger, endValue: flowATotalMaxValueLogger }}
                        allowDecimals={true}
                        title={{ text: flowATotalMinValueLogger === Number.NEGATIVE_INFINITY && flowATotalMaxValueLogger === Number.NEGATIVE_INFINITY ? `${logger.Serial} ${logger.ChannelARef} ${intl.formatMessage({ id: 'Total' })} - ${intl.formatMessage({ id: 'NO DATA' })} (${intl.formatMessage({ id: 'Totaliser A' })})` : `${logger.Serial} ${logger.ChannelARef} ${intl.formatMessage({ id: "In" })} ${flowATotalUnit} ${flowATotal24Hrs ? intl.formatMessage({ id: '-24hr Total' }) : ''} (${intl.formatMessage({ id: 'Totaliser A' })})`, font: { color: flowATotalColor, size: flowATotalLabelSize } }}
                        position={flowATotalAxisPosition}
                        color={flowATotalColor}
                        key={`AT-Total ${logger.Serial}`} // Unique key for each axis
                    >
                        <Label font={{ color: flowATotalColor }} />
                    </ValueAxis>
                );
            }
            if (flowAConsumptionVisibleLogger && item.channelsAvail & 0x01) {
                valueAxisArray.push(
                    <ValueAxis
                        width={2}
                        name={`AC-Consumption ${logger.Serial}`}
                        visualRange={{ startValue: flowAConsumptionMinValueLogger, endValue: flowAConsumptionMaxValueLogger }}
                        allowDecimals={true}
                        title={{ text: flowAConsumptionMinValueLogger === Number.NEGATIVE_INFINITY && flowAConsumptionMaxValueLogger === Number.NEGATIVE_INFINITY ? `${logger.Serial} ${logger.ChannelARef} ${intl.formatMessage({ id: 'Consumption' })} - ${intl.formatMessage({ id: 'NO DATA' })} (${intl.formatMessage({ id: 'Consumption A' })})` : `${logger.Serial} ${logger.ChannelARef} ${intl.formatMessage({ id: "In" })} ${flowAConsumptionUnit} ${flowAConsumption24Hrs ? intl.formatMessage({ id: '-24hr Consumption' }) : ''} (${intl.formatMessage({ id: 'Consumption A' })})`, font: { color: flowAConsumptionColor, size: flowAConsumptionLabelSize } }}
                        position={flowAConsumptionAxisPosition}
                        color={flowAConsumptionColor}
                        key={`AC-Consumption ${logger.Serial}`} // Unique key for each axis
                    >
                        <Label font={{ color: flowAConsumptionColor }} />
                    </ValueAxis>
                );
            }

            if (flowBVisibleLogger && item.channelsAvail & 0x02) {
                valueAxisArray.push(
                    <ValueAxis
                        width={2}
                        name={`B ${logger.Serial}`}
                        visualRange={{ startValue: flowBMinValueLogger, endValue: flowBMaxValueLogger }}
                        allowDecimals={true}
                        title={{ text: flowBMinValueLogger === Number.NEGATIVE_INFINITY && flowBMaxValueLogger === Number.NEGATIVE_INFINITY ? `${logger.Serial} ${logger.ChannelBRef} - ${intl.formatMessage({ id: 'NO DATA' })} (${intl.formatMessage({ id: 'Flow B' })})` : `${logger.Serial} ${logger.ChannelBRef} ${intl.formatMessage({ id: "In" })} ${flowBUnit} (${intl.formatMessage({ id: 'Flow B' })})`, font: { color: flowBColor, size: flowBLabelSize } }}
                        position={flowBAxisPosition}
                        color={flowBColor}
                        key={`B-${logger.Serial}`} // Unique key for each axis
                    >
                        <Label font={{ color: flowBColor }} />
                        {hasAlarms && alarms.length > 0 && renderAlarmSeries(item.alarms.filter(alarm => alarm.channel === 'B'), item)}
                    </ValueAxis>
                );
            }
            if (flowBTotalVisibleLogger && item.channelsAvail & 0x02) {
                valueAxisArray.push(
                    <ValueAxis
                        width={2}
                        name={`BT-Total ${logger.Serial}`}
                        visualRange={{ startValue: flowBTotalMinValueLogger, endValue: flowBTotalMaxValueLogger }}
                        allowDecimals={true}
                        title={{ text: flowBTotalMinValueLogger === Number.NEGATIVE_INFINITY && flowBTotalMaxValueLogger === Number.NEGATIVE_INFINITY ? `${logger.Serial} ${logger.ChannelBRef} ${intl.formatMessage({ id: 'Total' })} - ${intl.formatMessage({ id: 'NO DATA' })} (${intl.formatMessage({ id: 'Totaliser B' })})` : `${logger.Serial} ${logger.ChannelBRef} ${intl.formatMessage({ id: "In" })} ${flowBTotalUnit} ${flowBTotal24Hrs ? intl.formatMessage({ id: '-24hr Total' }) : ''} (${intl.formatMessage({ id: 'Totaliser B' })})`, font: { color: flowBTotalColor, size: flowBTotalLabelSize } }} ///here
                        position={flowBTotalAxisPosition}
                        color={flowBTotalColor}
                        key={`BT-Total ${logger.Serial}`} // Unique key for each axis
                    >
                        <Label font={{ color: flowBTotalColor }} />
                    </ValueAxis>
                );
            }
            if (flowBConsumptionVisibleLogger && item.channelsAvail & 0x02) {
                valueAxisArray.push(
                    <ValueAxis
                        width={2}
                        name={`BC-Consumption ${logger.Serial}`}
                        visualRange={{ startValue: flowBConsumptionMinValueLogger, endValue: flowBConsumptionMaxValueLogger }}
                        allowDecimals={true}
                        title={{ text: flowBConsumptionMinValueLogger === Number.NEGATIVE_INFINITY && flowBConsumptionMaxValueLogger === Number.NEGATIVE_INFINITY ? `${logger.Serial} ${logger.ChannelBRef} ${intl.formatMessage({ id: 'Consumption' })} - ${intl.formatMessage({ id: 'NO DATA' })} (${intl.formatMessage({ id: 'Consumption B' })})` : `${logger.Serial} ${logger.ChannelBRef} ${intl.formatMessage({ id: "In" })} ${flowBConsumptionUnit} ${flowBConsumption24Hrs ? intl.formatMessage({ id: '-24hr Consumption' }) : ''} (${intl.formatMessage({ id: 'Consumption B' })})`, font: { color: flowBConsumptionColor, size: flowBConsumptionLabelSize } }}
                        position={flowBConsumptionAxisPosition}
                        color={flowBConsumptionColor}
                        key={`BC-Consumption ${logger.Serial}`} // Unique key for each axis
                    >
                        <Label font={{ color: flowBConsumptionColor }} />
                    </ValueAxis>
                );
            }
            if (pressureCVisibleLogger && item.channelsAvail & 0x04) {

                valueAxisArray.push(
                    <ValueAxis
                        width={2}
                        name={`C ${logger.Serial}`}
                        visualRange={{ startValue: pressureCMinValueLogger, endValue: pressureCMaxValueLogger }}
                        allowDecimals={true}
                        title={{
                            text: pressureCMinValueLogger === Number.NEGATIVE_INFINITY && pressureCMaxValueLogger === Number.NEGATIVE_INFINITY ? `${logger.Serial} ${logger.ChannelCRef} - ${intl.formatMessage({ id: 'NO DATA' })} (${pressureCChannelName})` : `${logger.Serial} ${logger.ChannelCRef} ${intl.formatMessage({ id: "In" })} ${pressureCUnit} (${pressureCChannelName})`, font: { color: pressureCColor, size: pressureCLabelSize }
                        }}
                        position={pressureCAxisPosition}
                        color={pressureCColor}
                        key={`C-${logger.Serial}`} // Unique key for each axis
                    >
                        <Label font={{ color: pressureCColor }} />
                        {hasAlarms && alarms.length > 0 && renderAlarmSeries(item.alarms.filter(alarm => alarm.channel === 'C'), item)}
                    </ValueAxis>
                );
            }
            if (pressureDVisibleLogger && item.channelsAvail & 0x08) {
                valueAxisArray.push(
                    <ValueAxis
                        width={2}
                        name={`D ${logger.Serial}`}
                        visualRange={{ startValue: pressureDMinValueLogger, endValue: pressureDMaxValueLogger }}
                        allowDecimals={true}
                        title={{
                            text: pressureDMinValueLogger === Number.NEGATIVE_INFINITY && pressureDMaxValueLogger === Number.NEGATIVE_INFINITY ? `${logger.Serial} ${logger.ChannelDRef} - ${intl.formatMessage({ id: 'NO DATA' })} (${pressureDChannelName})` : `${logger.Serial} ${logger.ChannelDRef} ${intl.formatMessage({ id: "In" })} ${pressureDUnit} (${pressureDChannelName})`, font: { color: pressureDColor, size: pressureDLabelSize }
                        }}
                        position={pressureDAxisPosition}
                        color={pressureDColor}
                        key={`D-${logger.Serial}`} // Unique key for each axis
                    >
                        <Label font={{ color: pressureDColor }} />
                        {hasAlarms && alarms.length > 0 && renderAlarmSeries(item.alarms.filter(alarm => alarm.channel === 'D'), item)}
                    </ValueAxis>
                );
            }
            if (pressureEVisibleLogger && item.channelsAvail & 0x10) {
                valueAxisArray.push(
                    <ValueAxis
                        width={2}
                        name={`E ${logger.Serial}`}
                        visualRange={{ startValue: pressureEMinValueLogger, endValue: pressureEMaxValueLogger }}
                        allowDecimals={true}
                        title={{
                            text: pressureEMinValueLogger === Number.NEGATIVE_INFINITY && pressureEMaxValueLogger === Number.NEGATIVE_INFINITY ? `${logger.Serial} ${logger.ChannelERef} - ${intl.formatMessage({ id: 'NO DATA' })} (${pressureEChannelName})` : `${logger.Serial} ${logger.ChannelERef} ${intl.formatMessage({ id: "In" })} ${pressureEUnit} (${pressureEChannelName})`, font: { color: pressureEColor, size: pressureELabelSize }
                        }}
                        position={pressureEAxisPosition}
                        color={pressureEColor}
                        key={`E-${logger.Serial}`} // Unique key for each axis
                    >
                        <Label font={{ color: pressureEColor }} />
                        {hasAlarms && alarms.length > 0 && renderAlarmSeries(item.alarms.filter(alarm => alarm.channel === 'E'), item)}
                    </ValueAxis>
                );
            }
        });
        return valueAxisArray;
    };


    const renderAlarmSeries = (items, settings: GraphTemplate) => {
        let counter = 0
        let type = ""
        let unit = ""
        const alarmSeries = []
        items.forEach(item => {

            // if (settings.isAshridgeDefault) {
            switch (item.channel) {
                case "A":
                    type = intl.formatMessage({ id: "Flow" })
                    unit = unitsAndValues[0].graphSettings.flowAUnit
                    break
                case "B":
                    type = intl.formatMessage({ id: "Flow" })
                    unit = unitsAndValues[0].graphSettings.flowBUnit
                    break
                case "C":
                    type = window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: "Pressure" }) : intl.formatMessage({ id: "Pressure / Analog" })
                    unit = unitsAndValues[0].graphSettings.pressureCUnit
                    break
                case "D":
                    type = window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: "Pressure" }) : intl.formatMessage({ id: "Pressure / Analog" })
                    unit = unitsAndValues[0].graphSettings.pressureDUnit
                    break
                case "E":
                    type = window.location.hostname.includes('zonelog.net') ? intl.formatMessage({ id: "Pressure" }) : intl.formatMessage({ id: "Pressure / Analog" })
                    unit = unitsAndValues[0].graphSettings.pressureEUnit
                    break
            }


            // }
            if (item.operator === '>' && item.visible) {
                alarmSeries.push(<Strip startValue={item.maxValue} color={`${item.color}${item.transparency}`} key={`${item.color}${item.maxValue}`}>
                    <Label text={`${item.message} - ${intl.formatMessage({ id: 'Alarm' })} (${type} > ${item.maxValue} ${unit})`} font={{ size: item.labelSize, color: "#000000" }} ></Label>
                </Strip>)
                alarmSeries.push(<Strip startValue={item.minValue} endValue={item.maxValue} color={`#ffbf0030`} key={`${item.color}${item.maxValue}`}>
                </Strip>)
            }
            if (item.operator === '<' && item.visible) {
                alarmSeries.push(<Strip endValue={item.maxValue} startValue={item.minValue} color={`#ffbf00${item.transparency}`} key={`${item.color}${item.maxValue}`}>
                    <Label horizontalAlignment={'right'} text={`${item.message} - ${intl.formatMessage({ id: 'Alarm' })} (${type} < ${item.minValue} ${unit})`} font={{ size: item.labelSize, color: "#000000" }} ></Label>
                </Strip>)
                alarmSeries.push(<Strip endValue={item.minValue} color={`${item.color}${item.transparency}`} key={`${item.color}${item.maxValue}`}>

                </Strip>)
            }
            counter++

        })

        return alarmSeries
    }

    const customArgument = (date: Date): string => {
        if (moment(date).isSame(moment(date).startOf('day'), 'second')) {
            return moment(date).format('Do HH:mm')
        } else {
            return moment(date).format('HH:mm')
        }
    }




    

    const toggleDatePicker = ():void => {
        setShowDatePicker(!showDatePicker)
        setShowShowHide(false)
    }

    const toggleShowHideClick = ():void => {
        setShowShowHide(!showShowHide)
        setShowDatePicker(false)
    }

    


    const handleToggleFlow = (type: string): void => {

        const unitsAndValuesTemp = unitsAndValues

        unitsAndValuesTemp.forEach(logger => {
            const l = logger.graphSettings
            const chan = logger.channelsAvail
            if (type === 'Flow' || type === 'Digital') {
                const checked = !showFlow
                if (type === 'Flow') {
                    if (!l.flowAIsDigital) {
                        l.flowAVisible = checked
                    }
                    if (!l.flowBIsDigital && chan & 0x02) {
                        l.flowBVisible = checked
                    }
                    setShowFlow(checked)
                } else {
                    if (l.flowAIsDigital) {
                        console.log()
                        l.flowAVisible = checked
                    }
                    if (l.flowBIsDigital && chan & 0x02) {
                        l.flowBVisible = checked
                    }
                    setShowDigital(checked)
                }

            } else if (type === 'Pressure') {
                const checked = !showPressure
                if (chan & 0x04) {

                    l.pressureCVisible = checked
                    if (checked === false) {
                        l.pressureCDisplayAll = checked
                        setShowMinMax(checked)
                    }
                }
                if (chan & 0x08) {
                    l.pressureDVisible = checked
                    if (checked === false) {
                        l.pressureDDisplayAll = checked
                        setShowMinMax(checked)
                    }
                }
                if (!window.location.hostname.includes('zonelog.net') && (chan & 0x10)) {
                    l.pressureEVisible = checked
                    if (checked === false) {
                        l.pressureEDisplayAll = checked
                        setShowMinMax(checked)
                    }
                }

                setShowPressure(checked)
            } else if (type === 'Total') {
                const checked = !showTotal
                l.flowATotalVisible = checked
                if (chan & 0x02) {
                    l.flowBTotalVisible = checked
                }
                setShowTotal(checked)
            } else if (type === 'Consumption') {
                const checked = !showConsumption
                l.flowAConsumptionVisible = checked
                if (chan & 0x02) {
                    l.flowBConsumptionVisible = checked
                }
                setShowConsumption(checked)
            } else if (type === 'MinMax') {
                const checked = !showMinMax
                if (chan & 0x04) {
                    l.pressureCDisplayAll = checked
                }
                if (chan & 0x08) {
                    l.pressureDDisplayAll = checked
                }
                if (!window.location.hostname.includes('zonelog.net') && (chan & 0x10)) {
                    l.pressureEDisplayAll = checked
                }
                setShowMinMax(checked)
            }
        })

        setUnitsAndValues(unitsAndValuesTemp)
        toggleShowHideClick()
    }

    


    useEffect(() => {
        if (shouldReloadData) {
            handleRedrawClick()
            setShouldReloadData(false)
        }
    }, [startDate, endDate, shouldReloadData])

    const handleRedrawClick = (): void => {
        setShowDatePicker(!showDatePicker)
        setShowButton(false)
        setGraphData([])
        //setUnitsAndValues([])
        if (handleDateUpdate) {
            handleDateUpdate(startDate, endDate)
        }
        reloadData(location.state?.groupId ? location.state?.groupId : 0, location.state?.loggers, location.state?.site, true);
        setVisualRange({ startValue: startDate, endValue: endDate })
    }

    return (
        <div>
            {!isLandscape &&
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "80vh" }}>
                    <div>
                        <h4 style={{ textAlign: "center" }}><b><FormattedMessage id="Please rotate your screen" /></b></h4> 
                        <h4 style={{ textAlign: "center" }}><b><FormattedMessage id="to view the graph" /></b></h4>
                        <div style={{display: "flex", justifyContent: "center"} }>
                            <Lottie animationData={rotateScreenAnimation} loop={true} style={{ width: "50%" }} />
                        </div>
                        <div style={{ width: "100%", marginTop: 80 }}>
                            <FullWidthMobileButton disabled={false} text={'Back'} onClick={(): void => history.goBack()} color="error" />
                        </div>
                        
                    </div>
                    
                </div>
            }
            {isLandscape &&
            (loading ?
                <div style={{
                    position: 'relative', left: 'Calc(50% - 100px)', top: 'Calc(50vh - 200px)'
                }}>
                    <Loader color={undefined} />
                </div>
                : 
                <div style={{ position: "relative" }}>
                    
                    <div style={{ background: Ashridge, width: "100vw", height: 55, transform: isTablet ? "translate(-3.5vw, -3vh)" : "translate(-3.5vw, -8.5vh)", display: "flex", justifyContent: "space-evenly", alignItems: "center" }}>
                        <div style={{ width: 150 }}>
                            <FullWidthMobileButton disabled={false} text={'Back'} onClick={(): void => history.goBack()} color="error" />
                        </div>
                        <div style={{ width: 200 }}>
                            <FullWidthMobileButton disabled={false} text={'change date'} onClick={(): void => {toggleDatePicker() } } color="primary" />
                        </div>
                        
                        <div style={{ width: 200 }}>
                            <FullWidthMobileButton disabled={false} text={'show / hide'} onClick={(): void => { toggleShowHideClick() }} color="secondary" />
                        </div>
                    </div>
                    {showDatePicker &&
                        <SlideInAnimation direction="top" duration={1.2} delay={1} transitionAmount={400} isVisible={showDatePicker}>
                            <div style={{
                                background: Ashridge,
                                width: "100vw",
                                transform: isTablet ? "translate(-2.8vw, -3vh)" : "translate(-3.5vw, -8vh)",
                                display: "block",
                                justifyContent: "space-evenly",
                                alignItems: "center",
                                position: "absolute",
                                color: "white",
                                padding: "10px"

                            }}>
                                <div style={{display: "flex", justifyContent: "center", marginBottom: 10} }>
                                    <div style={{ width: "30%" }}>
                                        <FullWidthMobileButton disabled={false} color="secondary" onClick={(): void => setSpecifyTime(!specifyTime)} text={specifyTime ? "Date Only": "Custom Time"} />
                                    </div>
                                </div>
                                <DateRange
                                    startDate={startDate}
                                    endDate={endDate}
                                    rainfall={false}
                                    onDateChange={(
                                        startDateChange: Date,
                                        endDateChange: Date,
                                        rainfall: boolean | null,
                                        recent: boolean,
                                    ): void => onDateChange(
                                        startDateChange,
                                        endDateChange,
                                        rainfall,
                                        recent,
                                        setStartDate,
                                        setEndDate,
                                        setShouldReloadData,
                                        setShowButton,
                                        specifyTime
                                    )}
                                    type={specifyTime ? "datetime" : "date"}
                                    showButton={showButton}
                                    handleRedrawClick={handleRedrawClick} />
                                
                            </div>
                        </SlideInAnimation>}
                    {showShowHide && 
                        <SlideInAnimation direction="top" duration={1.2} delay={1} transitionAmount={400} isVisible={showShowHide}>
                            <div style={{
                                background: Ashridge,
                                width: "100vw",
                                transform: isTablet ? "translate(-2.8vw, -3vh)" : "translate(-3.5vw, -8vh)",
                                display: "flex",
                                justifyContent: "space-evenly",
                                alignItems: "center",
                                position: "absolute",
                                color: "white",
                                padding: "10px",
                                height: 60
                            }}>
                                {hasFlow && <div style={{ width: 100 }}>
                                    <FullWidthMobileButton disabled={false} text={intl.formatMessage({ id: "Flow" })} color={showFlow ? 'secondary' : 'error'} onClick={(): void => handleToggleFlow("Flow")} />
                                </div>}
                                {hasTotal && <div style={{ width: 100 }}>
                                    <FullWidthMobileButton disabled={false} text={intl.formatMessage({ id: "Total" })} color={showTotal ? 'secondary' : 'error'} onClick={(): void => handleToggleFlow("Total")} />
                                </div>}
                                {hasConsumption && <div style={{ width: 200 }}>
                                    <FullWidthMobileButton disabled={false} text={intl.formatMessage({ id: "Consumption" })} color={showConsumption ? 'secondary' : 'error'} onClick={(): void => handleToggleFlow("Consumption")} />
                                </div>}
                                {hasPressureChannels && <div style={{ width: 150 }}>
                                    <FullWidthMobileButton disabled={false} text={intl.formatMessage({ id: "Pressure" })} color={showPressure ? 'secondary' : 'error'} onClick={(): void => handleToggleFlow("Pressure")} />
                                </div>}
                                {showPressure && <div style={{ width: 150 }}>
                                    <FullWidthMobileButton disabled={false} text={intl.formatMessage({ id: "Min/Max" })} color={showMinMax ? 'secondary' : 'error'} onClick={(): void => handleToggleFlow("MinMax")} />
                                </div>}
                                {hasDigital && <div style={{ width: 100 }}>
                                    <FullWidthMobileButton disabled={false} text={intl.formatMessage({ id: "Digital" })} color={showDigital ? 'secondary' : 'error'} onClick={(): void => handleToggleFlow("Digital")} />
                                </div>}
                            </div>
                        </SlideInAnimation>
                    }
                    <p style={{ textAlign: "center" }}>{intl.formatMessage({ id: "If you have custom company / user settings set in " })} {window.location.hostname.includes('zonelog.net') ? 'ZONELOG.NET' : 'Aquaguard'} {intl.formatMessage({ id: " portal these settings will be used on the mobile graph" })}</p>
                    {graphData && graphData.length === 0 && <h4 style={{ textAlign: "center" }}><FormattedMessage id="There is no data available between this date range" /></h4> }
                    {graphData && graphData.length > 0 && <Chart
                        dataSource={graphData}
                        ref={chartRef}
                        width="100%"
                        height={isTablet ? 700 : 300}
                        style={{ marginTop: isTablet ? "30px" : 0 }}

                    >
                        <CommonSeriesSettings
                            argumentField="date"
                            ignoreEmptyPoints={true}
                            type={'line'}
                        >

                            <Point size={15} selectionMode="allArgumentPoints" />
                            <Font weight={900} size={40} />
                        </CommonSeriesSettings>
                        <CommonAxisSettings
                            valueMarginsEnabled={true}
                            minValueMargin={0}
                            maxValueMargin={0}
                        />

                        {graphData.length > 0 && loggers.map((logger) => {
                            return renderLoggerSeries(logger)
                        })}




                        {unitsAndValues && alarms && loggers.map((logger) => {
                            return renderValueAxis(logger)
                        })}

                        {/*{location && location.state && location.state.site &&*/}
                        {/*    renderSiteSeries()}*/}


                        <ArgumentAxis
                            width={2}
                            allowDecimals={false}
                            argumentType="date"
                            minValueMargin={0}
                            maxValueMargin={0}
                            visualRange={visualRange}
                            color={'#000000'}
                            discreteAxisDivisionMode="crossLabels"

                        >
                            <Label font={{ size: 16, color: '#000000' }} format={(date: Date): string => customArgument(date)} />
                            <GridChart visible={true} />
                            {loggers.length === 1 && renderImportedDataStrips(
                                unitsAndValues,
                                importData
                            )}
                        </ArgumentAxis>
                        {/*<Export enabled={true} />*/}
                        <Crosshair
                            enabled={true}
                            color="#949494"
                            width={3}
                            dashStyle="dot"
                        >
                            <Label
                                visible={true}
                                backgroundColor="#949494"
                            >
                                <Font
                                    color="#fff"
                                    size={14}
                                />
                            </Label>
                        </Crosshair>
                        <ZoomAndPan
                            allowMouseWheel={false}
                            argumentAxis="both"
                            valueAxis="both"
                            dragToZoom={true}
                            allowTouchGestures={true}

                        />
                        <Legend
                            visible={false}
                            position="outside"
                            horizontalAlignment="center"
                            verticalAlignment="top"

                        />
                        {<Tooltip
                            enabled={true}
                            contentRender={(point): React.ReactNode => renderTooltip(
                                point,
                                loggers,
                                intl,
                                loggerSiteDetails,
                                null,
                                unitsAndValues,
                                null,
                                null,
                                null,
                                null,
                                null,
                                null,
                                null,
                                null,
                                null,
                                combinedFlowUnits
                            )}
                            onHidden={(): void => setTooltipVisible(false)}
                        />}
                    </Chart>}
                </div>
            )
            }
        </div>
    )
}
export default MultiLoggerGraphMobile